import { Routes } from '@angular/router';
import { ReportDashboardComponent } from './components/report-dashboard.component';

export const reportRoutes: Routes = [
  {
    path: 'report',
    component: ReportDashboardComponent,
    data: {
      title: 'Reports',
      isNav:  true,
      icon: 'description',
      permissions: ['ReportModule.Reports:View']
    },
    children: [
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/report/routes.config.ts